import { Popover } from '@headlessui/react'
import logo from './assets/logo.png'
import apple from './assets/apple.png'
import googleplay from './assets/googleplay.png'
import iphone from './assets/iphone2.png'

export default function Apps() {
  return (
    <div className="bg-bg bg-repeat bg-contain bg-opacity-40 pb-4">
      <div className="hidden sm:block sm:absolute sm:inset-0" aria-hidden="true">
        <svg
          className="absolute bottom-0 right-0 transform translate-x-1/2 mb-48 text-gray-700 lg:top-0 lg:mt-28 lg:mb-0 xl:transform-none xl:translate-x-0"
          width={364}
          height={384}
          viewBox="0 0 364 384"
          fill="none"
        >
          <defs>
            <pattern
              id="eab71dd9-9d7a-47bd-8044-256344ee00d0"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect x={0} y={0} width={4} height={4} fill="currentColor" />
            </pattern>
          </defs>
          <rect width={364} height={384} fill="url(#eab71dd9-9d7a-47bd-8044-256344ee00d0)" />
        </svg>
      </div>
      <div className="relative">
        <Popover>
          <nav
            className="relative max-w-7xl mx-auto flex items-center justify-between px-8 sm:px-12"
            aria-label="Global"
          >
            <div className="flex items-center flex-1">
              <div className="flex items-center justify-between w-full md:w-auto">
                  <span className="sr-only">Workflow</span>
                  <img
                    className="h-20 w-auto sm:h-36"
                    src={logo}
                    alt=""
                  />
              </div>
            </div>
          </nav>
        </Popover>

        <main className="px-6">
          <div className="mx-auto max-w-7xl">
            <div className="lg:grid lg:grid-cols-12 lg:gap-8">
              <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:flex-start">
                <div>
                  <h1 className="text-4xl tracking-tight font-extrabold text-white sm:leading-none lg:text-3xl xl:text-6xl">
                    <span className="block">• Join our daily quizzes for the chance to win prizes</span>
                    <span className="text-indigo-400 block">• Play a quiz, win prizes</span>
                    <span className="block">• Want to win vouchers by winning quizzes?</span>
                  </h1>
                  <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-base">
                  Qazoo quiz gives everyone the chance to win prizes that can be worth hundreds of euro every day. Join a daily quiz, answer a few questions quicker than everyone else and take home vouchers for some of the biggest brands in the country.
                  </p>
                  {/* <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-base">
                  Qaqoo quiz gives you daily chances to win vouchers to
                  </p>
                  <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-base">
                  Download Qazoo, log in and play our daily quizzes to be in with the chance to win vouchers without spending a penny. Totally free to play with fun videos being the content of every quiz so no special education needed.</p> */}
       
                  <div className="mt-12 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                    <div className="flex flex-wrap items-start justify-between">
                      <div className="flex justify-center px-1">
                        <img
                         style={{
                          border: '1px solid white',
                          borderRadius: 12
                          }}
                          className="h-9 sm:h-14"
                          src={apple}
                          alt="download apple"
                        />
                      </div>
                      <div className="flex justify-center px-1">
                        <img
                        style={{
                          border: '1px solid white',
                          borderRadius: 12
                          }}
                          className="h-9 sm:h-14"
                          src={googleplay}
                          alt="download google"
                        />
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-10 lg:mt-0 lg:col-span-6">
                <div className="" style={{height: '670px'}}>
                   <div className="lg:pl-10 flex justify-center lg:-m-32">
                     <img
                      style={{height: '670px'}}
                          className=""
                          src={iphone}
                          alt="download google"
                        /></div> 
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}